<template>
  <div class="mb-5">
    <v-card flat outlined :loading="isMainLoading || isLoading" min-height="30">
      <v-card-title class="flex" style="justify-content: center;">
        <div>{{$t('market.select_month')}}</div>
        <div style="max-width:200px;" class="mx-5">
          <SelectMonthYear
            :isDisabled="isLoading"
            :startMonth="startMonth"
            :startYear="startYear"
            isOnChange
            @onSelect="onSelectMonthYear"
          />
        </div>
      </v-card-title>
      <v-card-text>
        <div class="sh-db">
          <div class="dashboard">
            <div class="dashboard-header">
              <div class="head">{{$t('market.rental_income')}}</div>
              <!-- <div>ในเดือนปัจจุบัน</div> -->
              <div class="tail">
                <div>{{$t('invoice.invoice_data')}}</div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>{{$t('invoice.invoice_data_by_monthly_rental_in_month')}}</div>
                </v-tooltip>
              </div>
            </div>
            <div class="dashboard-box">
              <div>{{$t('market.cumulative_rental_income')}}</div>
              <template v-if="!isLoading && dataIncomePrepare">
                <div class="h-number">
                  {{dataIncomePrepare.totalValue || 0 | currency}}
                  <span>{{ $helper.currencySign() }}</span>
                </div>
              </template>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
            <div class="dashboard-box">
              <div>{{$t('market.rental_income_in_month', {count: incomeData ? incomeData.monthYearFormat : '-'})}}</div>
              <template v-if="!isLoading && incomeData">
                <div class="h-number">
                  {{incomeData.total || 0 | currency}}
                  <span>{{ $helper.currencySign() }}</span>
                </div>
              </template>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
            <div class="dashboard-box">
              <div>{{$t('invoice.invoice_count_in_month', {count: incomeData ? incomeData.monthYearFormat : '-'})}}</div>
              <template v-if="!isLoading && incomeData">
                <div class="h-number">
                  {{incomeData.countInvoices || 0 | arabic}}
                  <span>{{ $t('bill.bill') }}</span>
                </div>
              </template>
              <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
            </div>
          </div>
        </div>
        <div class="gh">
          <div class="in">
            <div class="text-center mt-5" v-if="selectedMonthYear">
              <v-icon class="mr-1">mdi-chart-pie</v-icon>
              {{ $t('market.analyze_rental_income_monthly', { month: toMonthYearText(selectedMonthYear) }) }}
            </div>
            <div class="monthly-income-box">
              <div class="pie-chart-box">
                <canvas :id="`pie-chart-monthly-income-${tabType}`" v-show="incomeData && incomeData.total"></canvas>
                <div
                  v-show="incomeData && incomeData.total == 0"
                  class="no-data"
                >{{$t('market.no_income_in_this_month')}}</div>
              </div>
              <div v-if="incomeData" class="payment-method-box">
                <div class="mt-5 flex justify-space-between font-bold">
                  <div>
                    <v-icon color="success" class="mr-1">mdi-check-circle</v-icon>{{$t('market.paid_rental_total_income')}}
                  </div>
                  <div class="pl-10">{{incomeData.paid | currencySuffixTextThEn }}</div>
                </div>

                <div class="mt-5 flex justify-space-between font-bold">
                  <div>
                    <v-icon color="error" class="mr-1">mdi-close-circle</v-icon>{{$t('market.pending_rental_total_income')}}
                  </div>
                  <div class="pl-10">{{incomeData.unPaid | currencySuffixTextThEn }}</div>
                </div>
                <div
                  class="text-center mt-6 font-bold"
                  style="font-size:22px;"
                >{{$t('market.total_net_income', {count: $options.filters.currencySuffixTextThEn(incomeData.total || 0)})}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center ali mt-10">
          <v-icon class="mr-1">mdi-chart-bar</v-icon>{{ $t('market.summary_rental_income_monthly') }}
        </div>
        <div class="yearly-income-box">
          <div class="bar-chart-box">
            <canvas
              :id="`bar-chart-monthly-income-${tabType}`"
              v-show="dataIncomePrepare && dataIncomePrepare.totalValue"
            ></canvas>
            <div
              class="no-data"
              v-show="dataIncomePrepare && dataIncomePrepare.totalValue == 0"
            >{{$t('market.no_income_in_month')}}</div>
          </div>
        </div>
        <div class="yearly-income-box">
          <div class="bar-chart-box">
            <canvas
              :id="`bar-chart-monthly-income-yoy-${tabType}`"
              v-show="dataIncomePrepare && dataIncomePrepare.totalValue"
            ></canvas>
            <div
              class="no-data"
              v-show="dataIncomePrepare && dataIncomePrepare.totalValue == 0"
            >{{$t('market.no_income_in_month')}}</div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import SelectMonthYear from "@/components/SelectMonthYear.component";
Chart.register(ChartDataLabels);
let pieChartMonthlyIncome, barChartMonthlyIncome, barChartMonthlyIncomeYoY;
export default {
  name: "OverallIncomeMonthly",
  props: {
    isMainLoading: Boolean,
    tabType: {
      type: String,
      default: "THB"
    }
  },
  components: { SelectMonthYear },
  computed: {
    ...mapGetters({
      invoices: "invoice/getInvoiceOverallMonthly"
    })
  },
  data() {
    let _this = this;
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isSaveing: false,
      isLoading: false,
      rules: {
        required: value => !!value || this.$t('validate.please_select_list'),
        maxPercent: v => v <= 100 || this.$t('validate.please_max_percent'),
        minPercent: v => v > 0 || this.$t('validate.please_min_percent'),
        minCost: v => v > 0 || `${this.$t('validate.please_min_cost')}${this.$helper.currencySign()}`
      },
      startMonth:
        this.$moment()
          .add(1, "months")
          .month() + 1,
      startYear: this.$moment()
        .add(1, "months")
        .year(),
      selectedMonthYear: null,
      barChartYearlyIncome: {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          responsive: true,
          layout: {
            padding: {
              top: 40
            }
          },
          scales: {
            y: {
              ticks: {
                callback: function(value, index, ticks) {
                  return (
                    `${_this.$helper.currencySign()}` +
                    parseFloat(value)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  );
                }
              }
            }
          },
          plugins: {
            legend: {
              display: false
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 3,
              formatter: (val, context) => {
                let text;
                text = `${this.$helper.toCurrency(parseFloat(val || 0), null, { isAbbreviate: true, isPrefixSign: true })}`;
                return text;
              }
            }
          }
        }
      },
      paymentMethodcolors: {
        pending: "#F25C5D",
        cash: "#5fff5f",
        paid: "#5fff5f",
        bank_transfer: "#5fffd7",
        debit_credit: "#baff5f",
        bill_payment: "#5fffb4",
        deposit_deduction: "#5fa4ff",
        cash_check: "#c7ff5f",
        qr_payment: "#0f3e68"
      },
      isMountedCheckPieChart: false,
      isMountedCheckBarChart: false,
      isMountedCheckBarChartYoY: false,
      incomeData: null,
      dataIncomePrepare: null,
      dataIncome: null
    };
  },
  mounted() {
    this.isMountedCheckPieChart = true;
    this.isMountedCheckBarChart = true;
    this.isMountedCheckBarChartYoY = true;
  },
  methods: {
    async initData() {
      this.isLoading = true;
      if (!this.selectedMonthYear)
        this.selectedMonthYear = {
          month: this.startMonth,
          year: this.startYear
        };
      try {
        this.dataIncome = await this.getOverAllMonthlyInvoices();
        this.dataIncome = this.dataIncome.sort(
          (a, b) =>
            this.$moment(a.objectId, "M/YYYY") -
            this.$moment(b.objectId, "M/YYYY")
        );
        this.incomeData = await this.prepareDataInvoices(this.dataIncome);
        this.dataIncomePrepare = await this.prepareDataYearInvoices(
          this.dataIncome
        );

        // this.onSelectMonthYear(this.selectedMonthYear);

        //Create chart
        this.initPieChartMonthlyIncome(this.incomeData);
        this.initBarChartMonthlyIncome(this.dataIncomePrepare);
        this.initBarChartMonthlyIncomeYoY(this.dataIncomePrepare);

        this.isLoading = false;
      } catch (error) {
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        this.isLoading = false;
      }
    },
    getOverAllMonthlyInvoices() {
      return this.$store.dispatch("invoice/getOverAllMonthlyInvoices", {
        projectId: this.projectId,
        marketId: this.marketId
      });
    },
    onSelectMonthYear(data) {
      this.selectedMonthYear = data;
      this.initData();
    },
    prepareDataInvoices(invoices = this.invoices) {
      let dataRes = {
        paid: 0,
        unPaid: 0,
        total: 0,
        countInvoices: 0,
        countReceipts: 0,
        monthYear: `${this.selectedMonthYear.month}/${this.selectedMonthYear.year}`,
        monthYearFormat: this.$moment(
          `${this.selectedMonthYear.month}/${this.selectedMonthYear.year}`,
          "M/YYYY"
        ).format("MMMM YYYY")
      };
      if (invoices && invoices.length && this.selectedMonthYear) {
        let invoice = invoices.find(
          i =>
            i.objectId ==
            `${this.selectedMonthYear.month}/${this.selectedMonthYear.year}`
        );
        if (invoice) {
          dataRes.paid = invoice.totalPaidValue;
          dataRes.unPaid = invoice.totalValue - invoice.totalPaidValue;
          dataRes.total = invoice.totalValue;
          dataRes.countInvoices = invoice.count;
          // dataRes.countReceipts = invoice.data.receipts.length
        }
      }
      return dataRes;
    },
    prepareDataYearInvoices(dataIncomes) {
      let dataRes = {
        monthYear: [],
        count: 0,
        totalDiscountNonVatValue: 0,
        totalDiscountValue: 0,
        totalDiscountVatValue: 0,
        totalNonVatItemsValue: 0,
        totalNonVatValue: 0,
        totalPaidValue: 0,
        totalValue: 0,
        totalVatItemsValue: 0,
        totalVatValue: 0,
        totalWhtValue: 0,
        avgTotalValue: 0,
        lastMonth: "",
        lastMonthTotalValue: 0,
        lastMonthTotalDiscountValue: 0,
        lastMonthCount: 0,
        maxTotalValue: Math.max(...dataIncomes.map(o => o.maxTotalValue)),
        minTotalValue: Math.min(...dataIncomes.map(o => o.minTotalValue))
      };
      if (dataIncomes && dataIncomes.length) {
        let dataIncomeObjects = {};
        for (const dataIncome of dataIncomes) {
          dataIncomeObjects[dataIncome.objectId] = dataIncome;
        }
        let minimumMonths = 24;
        let monthYearStop = this.$moment(
          dataIncomes[dataIncomes.length - 1].objectId,
          "M/YYYY"
        );
        let monthYearStart = this.$moment(dataIncomes[0].objectId, "M/YYYY");
        let monthYearNumber = monthYearStop.diff(monthYearStart, "months");
        for (
          let numberOfMonth = 0;
          numberOfMonth <=
          (monthYearNumber < minimumMonths ? minimumMonths : monthYearNumber);
          numberOfMonth++
        ) {
          let monthYear = this.$moment(monthYearStop)
            .add(
              monthYearNumber < minimumMonths
                ? -minimumMonths
                : -monthYearNumber,
              "months"
            )
            .add(numberOfMonth, "months")
            .format("M/YYYY");
          let bfMonthYear = this.$moment(monthYearStop)
            .add(
              monthYearNumber < minimumMonths
                ? -minimumMonths
                : -monthYearNumber,
              "months"
            )
            .add(numberOfMonth - 1, "months")
            .format("M/YYYY");
          let aYearAgoMonthYear = this.$moment(monthYearStop)
            .add(
              monthYearNumber < minimumMonths
                ? -minimumMonths
                : -monthYearNumber,
              "months"
            )
            .add(numberOfMonth - 12, "months")
            .format("M/YYYY");
          let dataIncome = dataIncomeObjects[monthYear];
          let bfDataIncome = dataIncomeObjects[bfMonthYear];
          let aYearAgoDataIncome = dataIncomeObjects[aYearAgoMonthYear];
          if (dataIncome) {
            dataIncome.revenueGrowth = bfDataIncome
              ? (dataIncome.totalValue - bfDataIncome.totalValue) /
                bfDataIncome.totalValue
              : 0;
            dataIncome.differenceIncomePrevious = bfDataIncome
              ? dataIncome.totalValue - bfDataIncome.totalValue
              : dataIncome.totalValue;
            dataIncome.differenceYearIncome = aYearAgoDataIncome
              ? dataIncome.totalValue - aYearAgoDataIncome.totalValue
              : dataIncome.totalValue;
            dataIncome.bfYearIncome = aYearAgoDataIncome
              ? aYearAgoDataIncome.totalValue
              : 0;
            dataIncome.aYearAgoMonthYear = aYearAgoMonthYear;
            dataRes.monthYear.push(dataIncome);
            dataRes.count += dataIncome.count;
            dataRes.totalDiscountNonVatValue +=
              dataIncome.totalDiscountNonVatValue;
            dataRes.totalDiscountValue += dataIncome.totalDiscountValue;
            dataRes.totalDiscountVatValue += dataIncome.totalDiscountVatValue;
            dataRes.totalNonVatItemsValue += dataIncome.totalNonVatItemsValue;
            dataRes.totalNonVatValue += dataIncome.totalNonVatValue;
            dataRes.totalPaidValue += dataIncome.totalPaidValue;
            dataRes.totalValue += dataIncome.totalValue;
            dataRes.totalVatItemsValue += dataIncome.totalVatItemsValue;
            dataRes.totalVatValue += dataIncome.totalVatValue;
            dataRes.totalWhtValue += dataIncome.totalWhtValue;
            dataRes.avgTotalValue += dataIncome.avgTotalValue;
            if (monthYear == monthYearStop.format("M/YYYY")) {
              dataRes.lastMonth = this.$moment(
                dataIncome.objectId,
                "M/YYYY"
              ).format("MMMM YYYY");
              dataRes.lastMonthTotalValue = dataIncome.totalValue;
              dataRes.lastMonthCount = dataIncome.count;
              dataRes.lastMonthTotalDiscountValue =
                dataIncome.totalDiscountValue;
            }
          } else {
            dataRes.monthYear.push({
              avgTotalValue: 0,
              count: 0,
              differenceIncomePrevious: bfDataIncome
                ? 0 - bfDataIncome.totalValue
                : 0,
              differenceYearIncome: aYearAgoDataIncome
                ? 0 - aYearAgoDataIncome.totalValue
                : 0,
              bfYearIncome: aYearAgoDataIncome
                ? aYearAgoDataIncome.totalValue
                : 0,
              maxTotalValue: 0,
              minTotalValue: 0,
              objectId: monthYear,
              revenueGrowth: bfDataIncome
                ? (0 - bfDataIncome.totalValue) / bfDataIncome.totalValue
                : 0,
              totalDiscountNonVatValue: 0,
              totalDiscountValue: 0,
              totalDiscountVatValue: 0,
              totalNonVatItemsValue: 0,
              totalNonVatValue: 0,
              totalPaidValue: 0,
              totalValue: 0,
              totalVatItemsValue: 0,
              totalVatValue: 0,
              totalWhtValue: 0
            });
          }
        }
        dataRes.avgTotalValue = dataRes.avgTotalValue / dataIncomes.length;
      }
      return dataRes;
    },
    initPieChartMonthlyIncome(dataRes) {
      let _this = this;
      let dataChart = {
        type: "pie",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          layout: {
            padding: {
              top: 20,
              left: 40,
              right: 40
            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: true
              // callbacks: {
              //   footer: ttItem => {
              //     let sum = 0;
              //     let dataArr = ttItem[0].dataset.data;
              //     dataArr.map(data => {
              //       sum += Number(data);
              //     });
              //     let percentage =
              //       ((ttItem[0].parsed * 100) / sum).toFixed(2) + "%";
              //     return `สัดส่วนรายรับ ${percentage}`;
              //   }
              // }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 3,
              formatter: (val, context) => {
                let text;
                text = `${_this.$helper.toCurrency(parseFloat(val || 0), null, { isAbbreviate: true, isPrefixSign: true })}`;
                return text;
              }
            }
          },
          responsive: true
        },
        plugins: [ChartDataLabels]
      };
      dataChart.data.labels = [this.$t('payment.pending'), this.$t('payment.paid')];
      dataChart.data.datasets[0] = {
        label: "Monthly Income",
        data: [dataRes.unPaid, dataRes.paid],
        backgroundColor: ["#F25C5D", "#5fff5f"]
      };
      if (!pieChartMonthlyIncome || this.isMountedCheckPieChart) {
        let ctx = document.getElementById(`pie-chart-monthly-income-${this.tabType}`);
        if (ctx) pieChartMonthlyIncome = new Chart(ctx, dataChart);
        this.isMountedCheckPieChart = false;
      } else {
        pieChartMonthlyIncome.data = dataChart.data;
        pieChartMonthlyIncome.update();
      }
    },
    initBarChartMonthlyIncome(dataIncomePrepare) {
      let _this = this;
      let dataChart = {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          responsive: true,
          layout: {
            padding: {
              // top:50
            }
          },
          scales: {
            y: {
              ticks: {
                callback: function(value, index, ticks) {
                  return (
                    `${_this.$helper.currencySign()}` +
                    parseFloat(value)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  );
                }
              }
            },
            y1: {
              display: false,
              type: "linear",
              position: "right",
              beginAtZero: true
            }
          },
          plugins: {
            labels: {
              render: "value"
            },
            title: {
              text: this.$t('market.rental_income_and_growth_rate_graph'),
              display: true
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function(context) {
                  let text;
                  if (context.datasetIndex == 0) {
                    text = `${context.dataset.label} : ${
                      _this.$helper.toCurrency(parseFloat(context.raw || 0), null, { isPrefixSign: true, isNoSpace: true })
                    }`;
                  } else if (context.datasetIndex == 1) {
                    text = `${context.dataset.label} : ${
                      _this.$helper.toCurrency((parseFloat(context.raw) * 100), null)
                    }%`;
                  }
                  return text;
                },
                footer: context => {
                  let text;
                  let dataIncome = this.dataIncomePrepare.monthYear.find(
                    d => d.objectId == context[0].label
                  );
                  if (dataIncome)
                    text = `${this.$t('market.rental_income_difference_from_previous_month')}: ${
                      _this.$helper.toCurrency(parseFloat(dataIncome.differenceIncomePrevious || 0), null, { isShowPlus: true, isPrefixSign: true, isNoSpace: true, mathType: "outSide" })
                    }`;
                  return text;
                }
              }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              textAlign: "center",
              textStrokeColor: "#FFFFFF50",
              textStrokeWidth: 1,
              // textShadowColor:'#FFFFFF',

              color: function(context) {
                let color = "#00000099";
                if (context.datasetIndex == 0) {
                  color = `#00000099`;
                } else if (context.datasetIndex == 1) {
                  color =
                    context.dataset.data[context.dataIndex] >= 0
                      ? `#17dd95D0`
                      : `#F25C5DD0`;
                }
                return color;
              },
              formatter: (val, context) => {
                let text;
                let dataIncome = this.dataIncomePrepare.monthYear.find(
                  d =>
                    d.objectId == context.chart.data.labels[context.dataIndex]
                );
                if (context.datasetIndex == 0) {

                  text = `${_this.$helper.toCurrency(parseFloat(val || 0), null, { isAbbreviate: true, isPrefixSign: true, isNoSpace: true, mathType: "outSide" })}`;
                } else if (context.datasetIndex == 1) {
                  text = `${
                    _this.$helper.toCurrency((parseFloat(val) * 100), null, { isShowPlus: true, isPrefixSign: true, mathType: "outSide" })
                    }%${dataIncome
                      ? "\n" + _this.$helper.toCurrency(parseFloat(dataIncome.differenceIncomePrevious || 0), null, { isAbbreviate: true, isPrefixSign: true, isShowPlus: true, mathType: "outSide" })
                      : ""
                  }`;
                }
                return text;
              }
            }
          }
        },
        plugins: [ChartDataLabels, {
          id: "legendMargin",
          beforeInit: function(chart, options) {
            const fitValue = chart.legend.fit
            chart.legend.fit = function fit(){
              fitValue.bind(chart.legend)()
              return this.height += 40
            }
          }
        }]
      };
      dataChart.data.labels = [];
      dataChart.data.datasets[0] = {
        label: this.$t('market.rental_income_only'),
        type: "bar",
        data: [],
        backgroundColor: ["#5fffd740"],
        borderColor: ["#5fffd7"],
        borderWidth: 1,
        order: 1
      };
      dataChart.data.datasets[1] = {
        label: this.$t('market.growth_rate_of_rental_income'),
        type: "line",
        data: [],
        backgroundColor: "rgb(255, 239, 149)",
        borderColor: "rgba(255, 221, 30, 0.5)",
        tension: 0.3,
        fill: false,
        yAxisID: "y1",
        order: 0
      };

      for (const index in dataIncomePrepare.monthYear) {
        if (dataIncomePrepare.monthYear.length - index <= 12) {
          let dataIncome = dataIncomePrepare.monthYear[index];
          dataChart.data.labels.push(dataIncome.objectId);
          dataChart.data.datasets[0].data.push(dataIncome.totalValue);
          dataChart.data.datasets[1].data.push(dataIncome.revenueGrowth);
        }
      }
      if (!barChartMonthlyIncome || this.isMountedCheckBarChart) {
        var ctx = document.getElementById(`bar-chart-monthly-income-${this.tabType}`);
        if (ctx) barChartMonthlyIncome = new Chart(ctx, dataChart);
        this.isMountedCheckBarChart = false;
      } else {
        barChartMonthlyIncome.update();
      }
    },
    initBarChartMonthlyIncomeYoY(dataIncomePrepare) {
      let _this = this;
      let dataChart = {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          responsive: true,
          layout: {
            padding: {
              // top:50
            }
          },
          scales: {
            y: {
              ticks: {
                callback: function(value, index, ticks) {
                  return `${_this.$helper.toCurrency(parseFloat(value), null, { isPrefixSign: true, isNoSpace: true })}`;
                }
              }
            },
            y1: {
              display: false,
              type: "linear",
              position: "right",
              beginAtZero: true
            }
          },
          plugins: {
            labels: {
              render: "value"
            },
            title: {
              text: this.$t('market.rental_income_change_over_year_graph'),
              display: true
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (context) {
                  let text;
                  if (context.datasetIndex == 0) {
                    text = `${context.dataset.label} : ${
                      _this.$helper.toCurrency(parseFloat(context.raw || 0), null, { isPrefixSign: true, isShowPlus: true, isNoSpace: true, mathType: "outSide" })
                    }`;
                  } else if (context.datasetIndex == 1) {
                    text = `${context.dataset.label} : ${
                      _this.$helper.toCurrency((parseFloat(context.raw) * 100), null, { isShowPlus: true, isPrefixSign: true, isNoSpace: true, mathType: "outSide" })
                    }%`;
                  }
                  return text;
                },
                footer: context => {
                  let text;
                  let dataIncome = this.dataIncomePrepare.monthYear.find(
                    d => d.objectId == context[0].label
                  );
                  if (dataIncome)
                    text = `${this.$t('market.income_from')} ${context[0].label} : ${
                      _this.$helper.toCurrency(parseFloat(dataIncome.totalValue || 0), null, { isPrefixSign: true })
                    }\n${this.$t('market.income_from')} ${dataIncome.aYearAgoMonthYear
                      } : ${_this.$helper.toCurrency(parseFloat(dataIncome.bfYearIncome || 0), null, { isPrefixSign: true })}`;
                  return text;
                }
              }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              padding: {
                // top:150
              },
              font: {
                size: 15,
                weight: "bold"
              },
              textAlign: "center",
              textStrokeColor: "#FFFFFF50",
              textStrokeWidth: 1,
              // textShadowColor:'#FFFFFF',

              color: function(context) {
                let color = "#00000099";
                if (context.datasetIndex == 0) {
                  color =
                    context.dataset.data[context.dataIndex] == 0
                      ? `#00000099`
                      : context.dataset.data[context.dataIndex] > 0
                      ? `#17dd95D0`
                      : `#F25C5DD0`;
                } else if (context.datasetIndex == 1) {
                  color =
                    context.dataset.data[context.dataIndex] >= 0
                      ? `#5fff5fD0`
                      : `#F25C5DD0`;
                }
                return color;
              },
              formatter: (val, context) => {
                let text;
                let dataIncome = this.dataIncomePrepare.monthYear.find(
                  d =>
                    d.objectId == context.chart.data.labels[context.dataIndex]
                );
                if (context.datasetIndex == 0) {
                  text = `${
                    _this.$helper.toCurrency(parseFloat(val || 0), null, { isAbbreviate: true, isPrefixSign: true, isShowPlus: true, mathType: "outSide" })
                  }`;
                } else if (context.datasetIndex == 1) {
                  text = `${
                    _this.$helper.toCurrency((parseFloat(val) * 100), null, { isShowPlus: true, mathType: "outSide" })
                    }%${dataIncome
                      ? "\n" + _this.$helper.toCurrency(parseFloat(dataIncome.differenceIncomePrevious || 0), null, { isAbbreviate: true, isPrefixSign: true, isShowPlus: true, mathType: "outSide" })
                      : ""
                  }`;
                }
                return text;
              }
            }
          }
        },
        plugins: [ChartDataLabels, {
          id: "legendMargin",
          beforeInit: function(chart, options) {
            const fitValue = chart.legend.fit
            chart.legend.fit = function fit(){
              fitValue.bind(chart.legend)()
              return this.height += 20
            }
          }
        }]
      };
      dataChart.data.labels = [];
      dataChart.data.datasets[0] = {
        label: this.$t('market.rental_income_change'),
        type: "bar",
        data: [],
        backgroundColor: "#ffdcb570",
        borderColor: "#ffa33a",
        borderWidth: 1,
        order: 1
      };

      for (const index in dataIncomePrepare.monthYear) {
        if (dataIncomePrepare.monthYear.length - index <= 12) {
          let dataIncome = dataIncomePrepare.monthYear[index];
          dataChart.data.labels.push(dataIncome.objectId);
          dataChart.data.datasets[0].data.push(dataIncome.differenceYearIncome);
          // dataChart.data.datasets[1].data.push(dataIncome.revenueGrowth);
        }
      }
      if (!barChartMonthlyIncomeYoY || this.isMountedCheckBarChartYoY) {
        var ctx = document.getElementById(`bar-chart-monthly-income-yoy-${this.tabType}`);
        if (ctx) barChartMonthlyIncomeYoY = new Chart(ctx, dataChart);
        this.isMountedCheckBarChartYoY = false;
      } else {
        barChartMonthlyIncomeYoY.update();
      }
    },
    toMonthYearText(data, sub = 0) {
      let text = "";
      if (data) {
        let month = data.month,
          year = data.year;
        text = this.$moment(`${month}/${year}`, "M/YYYY")
          .add(sub * -1, "months")
          .format("MMMM/YYYY");
      }
      return text;
    },
  }
};
</script>

<style lang="scss" scoped>
.monthly-income-box {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;

  .pie-chart-box {
    width: 300px;
    height: 300px;
    margin: 20px 20px 30px;
  }
  .payment-method-box {
    margin: 20px 20px 30px;
    div {
      margin-bottom: 7px;
    }
  }
}
.yearly-income-box {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  .bar-chart-box {
    width: 60vw;
    height: auto;
    min-height: 400px;
  }
}
.pie-chart-box .no-data,
.bar-chart-box .no-data {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  background: rgba(211, 211, 211, 0.281);
  border-radius: 20%;
}
.bar-chart-box .no-data {
  border-radius: 5px;
}

.sh-db {
  display: flex;
  justify-content: center;
  // flex-flow: row wrap;
  margin: 15px 0 25px;
  gap: 15px;

  .dashboard {
    display: flex;
    background: rgba(230, 230, 230, 0.35);
    border-radius: 15px;
    max-width: max-content;
    flex-wrap: wrap;
    .dashboard-header {
      padding: 25px;
      min-width: 202px;
      .head {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 10px;
      }
      .tail {
        display: inline-flex;
        font-style: italic;
        color: rgba(128, 128, 128, 0.527);
        align-items: center;
        i {
          margin-left: 2px;
          font-size: 15px;
          color: rgba(128, 128, 128, 0.527);
        }
      }
      .select-month-year {
        max-width: 200px;
        margin: 10px 0;
      }
    }
    .dashboard-box {
      position: relative;
      width: max-content;
      padding: 10px 20px;
      z-index: 1;
      font-size: 15px;
      text-align: center;
      .h-number {
        font-size: 30px;
        padding: 10px 0 5px;
        span {
          font-size: 15px;
        }
      }
      i {
        font-size: 15px;
      }
      .icon-box {
        display: inline-flex;
        padding: 5px 0 15px 0;
        i {
          color: #ffffff;
          font-size: 30px;
          box-shadow: 0 4px 4px -2px gray;
          border-radius: 50%;
          padding: 10px;
        }
        i.cash {
          background: #5d87ff;
        }
        i.bill {
          background: #27c5da;
        }
        i.discount {
          background: #f9896b;
        }
        i.booking {
          background: #ffaf1d;
        }
        i.renter {
          background: #17dd95;
          // background: #ffa33a;
        }
        i.area {
          background: #4abeff;
        }
        .image-icon {
          box-shadow: 0 4px 4px -2px gray;
          border-radius: 50%;
          padding: 10px;
        }
        .image-icon.area {
          background: #4abeff;
          img {
            padding: 4px;
            width: 30px;
            object-fit: contain;
            object-position: center;
          }
        }
      }
      span.plus {
        font-size: 18px;
        color: rgb(45, 192, 0);
      }
    }
    .dashboard-box:before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 70%;
      border-left: 1px solid rgba(167, 167, 167, 0.507);
    }
    .dashboard-input {
      display: flex;
      align-items: center;
      justify-items: center;
      margin-right: 15px;
    }
  }
}
.gh {
  display: flex;
  justify-content: center;
  .in {
    background: rgba(230, 230, 230, 0.35);
    border-radius: 15px;
    padding: 20px 15px;
  }
}
</style>